const Items = [
    {
        number: 1,
        question: '¿Cuál es tu único consuelo tanto en la vida como en la muerte?',
        answer: 'Que yo, con cuerpo y alma, tanto en la vida como en la muerte (a), no me pertenezco a mí mismo (b), sino a mi fiel Salvador Jesucristo (c), que me libró del poder del diablo (d), satisfaciendo enteramente con preciosa sangre por todos mis pecados (e), y me guarda de tal manera (f) que sin la voluntad de mi Padre celestial ni un solo cabello de mi cabeza puede caer (g) antes es necesario que todas las cosas sirvan para mi salvación (h). Por eso también me asegura, por su Espíritu Santo, la vida eterna (i) y me hace pronto y aparejado para vivir en adelante según su santa voluntad.',
        proofs: [
            {
                punto: 'a',
                ref: 'Romanos 14:8',
                text: 'TODO'
            },
            {
                punto: 'b',
                ref: '1 Corintios 6:19',
                text: 'TODO'
            },
            {
                punto: 'c',
                ref: '1 Corintios 3:23',
                text: 'TODO'
            },
            {
                punto: 'c',
                ref: 'Tito 2:14',
                text: 'TODO'
            },
            {
                punto: 'd',
                ref: 'Hebreos 2:14',
                text: 'TODO'
            },
            {
                punto: 'd',
                ref: '1 Juan 3:8',
                text: 'TODO'
            },
            {
                punto: 'd',
                ref: 'Juan 8:34-36',
                text: 'TODO'
            },
            {
                punto: 'e',
                ref: '1 Pedro 1:18-19',
                text: 'TODO'
            },
            {
                punto: 'e',
                ref: '1 Juan 1:7',
                text: 'TODO'
            },
            {
                punto: 'e',
                ref: '1 Juan 2:22',
                text: 'TODO'
            },
            {
                punto: 'f',
                ref: 'Juan 6:39',
                text: 'TODO'
            },
            {
                punto: 'f',
                ref: 'Juan 10:28',
                text: 'TODO'
            },
            {
                punto: 'f',
                ref: '2 Tesalonicenses 3:3',
                text: 'TODO'
            },
            {
                punto: 'f',
                ref: '1 Pedro 1:5',
                text: 'TODO'
            },
            {
                punto: 'g',
                ref: 'Mateo 10:30',
                text: 'TODO'
            },
            {
                punto: 'g',
                ref: 'Lucas 21:18',
                text: 'TODO'
            },
            {
                punto: 'h',
                ref: 'Romanos 8:28',
                text: 'TODO'
            },
            {
                punto: 'i',
                ref: '2 Corintios 1:22',
                text: 'TODO'
            },
            {
                punto: 'i',
                ref: '2 Corintios 5:5',
                text: 'TODO'
            },
            {
                punto: 'i',
                ref: 'Efesios 1:14',
                text: 'TODO'
            },
            {
                punto: 'i',
                ref: 'Romanos 8:16',
                text: 'TODO'
            },
            {
                punto: 'j',
                ref: 'Romanos 8:14',
                text: 'TODO'
            },
            {
                punto: 'j',
                ref: '1 Juan 3:3',
                text: 'TODO'
            },
        ]
    },
];

export default Items;